module.exports = __webpack_public_path__ + "img/discord.d74865e1.png";